import Layout from '../../components/Layout.js'; 

import './error.css';

function UnderConstructionPage() {
    return (
        <Layout pageIndex={-2}>
            <div style={{height:"70dvh", paddingTop:"128px"}}>

            <h1 className='errorcodeText'>Under Construction</h1>
            <p className='errorcodeSubtitle'>I'm still in the process of building this page! Check back later to see if I'm finished.</p>

            </div>
        </Layout>
    );
}

export default UnderConstructionPage;
